import {combineReducers} from "redux"
import projects from "./ProjectsReducer"
import clients from './ClientsReducer'
import entries from './EntriesReducer'
import invites from './InvitesReducer'
import tasks from './TasksReducer'
import teams from './TeamsReducer'
import users from './UsersReducer'
import message from './MessageReducer'
import authListener from './AuthListenerReducer'

export default combineReducers({
    clients,
    entries,
    projects,
    invites,
    tasks,
    teams,
    users,
    message,
    authListener
});


// WEBPACK FOOTER //
// ./src/reducers/index.js